import Button from '@mui/material/Button';
import React from 'react';
import { textToTextNumberModifier } from '../../helpers/text-to-number-modifier';
import {removeTrailingZeros} from '../../helpers/formatters';
import CryptoIcon from '../CryptoIcon/CryptoIcon';
import LPIcon from '../LPIcon/LPIcon';
import "./AmountInput.scss";
import {baseAssetOverride} from "../trade-tabs/helpers/position-columns";

const parseLPTokens = (asset: string): { isLP: boolean; token0?: string; token1?: string } => {
    if (asset.toUpperCase().endsWith(' LP') || asset.toUpperCase().endsWith('-LP')) {
        const withoutLP = asset.replace(/ LP$/i, '').replace(/-LP$/i, '');
        const tokens = withoutLP.split('-');
        if (tokens.length === 2) {
            return { isLP: true, token0: tokens[0], token1: tokens[1] };
        }
    }
    return { isLP: false };
};

export interface AmountInputProps {
    label?: string;
    available?: number | string;
    asset?: string;
    hasMaxButton?: boolean;
    onChange?: (value: string) => void;
    value?: number | string;
    shouldAdjustToMaxAmount?: boolean;
    precision?: number;
    placeholder?: string;
}

const AmountInput: React.FC<AmountInputProps> = ({
                                                     label,
                                                     available,
                                                     asset,
                                                     hasMaxButton,
                                                     onChange,
                                                     value = 0,
                                                     precision = 6,
                                                     placeholder,
                                                     shouldAdjustToMaxAmount
                                                 }) => {

    const handleMaxClick = () => {
        if (available !== undefined && onChange) {
            onChange(removeTrailingZeros(String(available)));
        }
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let inputVal = event.target.value;

        inputVal = textToTextNumberModifier(inputVal, precision);

        // Call onChange if it's provided
        if (onChange) {
            onChange(inputVal);
        }
    };

    return (
        <div className="AmountInput">
            <div className="AmountInput__firstRow">
                <div>
                    <label className="AmountInput__label">{label}</label>
                </div>
                {(available !== undefined) && (<div>
                    <label className="AmountInput__available">Available: {available}</label>
                    {hasMaxButton && (<Button variant="outlined" className="AmountInput__maxButton"
                                              onClick={handleMaxClick}>MAX</Button>)}
                </div>)}
            </div>
            <div className="AmountInput__secondRow">
                <div>
                    <input disabled={!onChange} className="AmountInput__input" placeholder={placeholder ||''} type="string" value={value || ''}
                                         onChange={handleInputChange}/>
                </div>
                {asset && (<div className="AmountInput__assetInfo">
                    {(() => {
                        const lpInfo = parseLPTokens(asset);
                        if (lpInfo.isLP && lpInfo.token0 && lpInfo.token1) {
                            return <LPIcon token0={lpInfo.token0} token1={lpInfo.token1} size={20} />;
                        }
                        return <CryptoIcon size={16} ticker={asset}/>;
                    })()}
                    <span className="ml-1 uppercase">{baseAssetOverride(asset)}</span>
                </div>)}
            </div>

        </div>
    );
};

export default AmountInput;
